<template>
  <div class="display">
    <v-alert v-show="true" color="primary" value="true" outline>
      Ces réglages affectent le contenu du widget lorsqu'aucun agent n'est connecté/en ligne sur le site <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>    
    <v-alert v-show="displayDefault === 'default_agents'" color="secondary" icon="warning" value="true" outline>
      Attention. Vous avez choisi, dans la section "Widget", de ne pas afficher de widget en mode hors-ligne (c'est à dire quand aucun agent n'est disponible pour le chat). Le widget étant invisible, les paramètres du mode hors-ligne,ci dessous, seront inopérants.
    </v-alert>
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
	<div v-else>

    <!-- Messaging  ON / OFF -->
    <v-card class="mb-3">
      <v-card-text>
        <v-layout row>
          <v-flex xs3>
            <v-switch 
              :label="messagingOnOff ? 'MESSAGING ON' : 'MESSAGING OFF'" 
              v-model="messagingOnOff"
              light
              color="primary"
              @click.native.stop="switchMessaging()"
              :disabled="testBrideStatus('parametre_messaging')"
            ></v-switch>
            <v-switch 
              :label="absOnOff ? 'FORMULAIRE EN ABSENCE ON' : 'FORMULAIRE EN ABSENCE OFF'" 
              light
              v-model="absOnOff"
              color="primary"
              @click.native.stop="switchAbs()"
              :disabled="testBrideStatus('parametre_messaging')"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-expansion-panel
      v-if="!messagingOnOff"
    >
      <!-- formulaire en absence-->
      <v-expansion-panel-content
        :disabled="testBrideStatus('parametre_chat_formprechat') || messagingOnOff"
      >
        <div slot="header"><v-icon class="mr-2 primary--text">assignment</v-icon>Personnalisation du formulaire en absence <!--<code>{{ abs.active ? $t("yes") : $t("no") }}</code>--></div>
        <v-card class="mb-3">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <!-- Customiser le formulaire -->
                <v-switch 
                  label="Personnaliser le formulaire"
                  v-model="abs.active"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-layout>


            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-subheader>Cocher les champs à valider</v-subheader>
                <v-layout row wrap v-for="(field, a) in itemsFieldsAbs" :key="a">
                  <v-flex sm3>
                    <v-checkbox 
                      :disabled="!abs.active || field.value === 'question'"
                      :label="field.text"
                      v-model="abs.labels"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex> 
                  <v-flex sm3>
                    <v-checkbox 
                      :disabled="!abs.active || field.value === 'question'"
                      label="Obligatoire"
                      v-model="abs.required"
                      :value="field.value"
                      class="primary--text"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <!-- Mention RGPD -->
                <v-text-field 
                  v-model="abs.rgpd"
                  label="Mention RGPD"
                  data-vv-name="abs.rgpd"
                  :error="wzErrors.has('abs.rgpd')"
                  :error-messages="wzErrors.collect('abs.rgpd')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <!-- personnalisation titre-->
      <v-expansion-panel-content
        :disabled="testBrideStatus('parametre_apercu_message1') || messagingOnOff"
      >
        <div slot="header">
          <v-icon class="mr-2 primary--text">text_fields</v-icon>
          {{ $t("firstLineMessage") | cap }}
        </div>
        <v-card>
          <v-card-text>
            <v-text-field v-for="(l, i) in langs" :key="i" v-model="DSK_NOBODY_MSG1[l.value]" :label="l.text"></v-text-field>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <!-- personnalisation sous-titre-->
      <v-expansion-panel-content
        :disabled="testBrideStatus('parametre_apercu_message2') || messagingOnOff"
      >
        <div slot="header">
          <v-icon class="mr-2 primary--text">text_fields</v-icon>
          {{ $t("secondLineMessage") | cap }}
        </div>
        <v-card>
          <v-card-text>
            <v-text-field v-for="(l, i) in langs" :key="i" v-model="DSK_NOBODY_MSG2[l.value]" :label="l.text"></v-text-field>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Validation du formulaire -->
    <div class="text-xs-right">
      <v-btn
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        :loading="loadingPost"
        @click.native="postOptions()"
      >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
      </v-btn>
    </div>

    <!-- ON OFF MESSAGING -->
    <v-dialog v-model="warningMessagingOff" max-width="390" persistent>
      <v-card>
        <v-card-title class="title primary white--text">
          Activation du mode messaging
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text >
          <strong>Attention</strong>, vous êtes sur le point d'activer le messaging (mode de discussion hors-ligne). Le formulaire en abscence ne sera pas proposé. A la place les internautes pourrons laisser des messages hors-lignes (via le chat) aux agents.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="warningMessagingOff = false">Continuer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningMessagingOn" max-width="390" persistent>
      <v-card>
        <v-card-title class="title primary white--text">
          Désactivation du mode messaging
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text >
          <strong>Attention</strong>, vous êtes sur le point de couper le messaging (mode de discussion hors-ligne). Vos internautes ne pourrons pas laisser de message hors-lignes aux agents (via le chat). A la place, ils se verront proposer un formulaire en absence.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="warningMessagingOn = false">Continuer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog Infos -->
    <wz-dialog-infos
      @fermeDialog="fermeDialogInfos"
      :titleDialog="titleDialog"
      :contentDialog="contentDialog"
    >
    </wz-dialog-infos>

    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=2
    >
    </wz-dialog-progress>
  </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      dialogProgress: false,
      messagingOnOff: false,
      absOnOff: true,
      warningMessagingOff: false,
      warningMessagingOn: false,
      titleDialog: '',
      contentDialog: '',
      abs: {
        active: true,
        rgpd: '',
        fields: [],
        required: ['question']
      },
      DSK_NOBODY_MSG1: '',
      DSK_NOBODY_MSG2: '',
      langs: [
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ],
      displayDefault: {},
      itemsFieldsAbs: [
        { text: 'Prénom', value: 'fname' },
        { text: 'Nom', value: 'lname' },
        { text: 'Téléphone', value: 'tel' },
        { text: 'Email', value: 'email' },
        { text: 'Société', value: 'company' },
        { text: 'Question/Message', value: 'question' }
      ],

      // loaders
      loadingGet: false,
      loadingPost: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      showDialogMotif: false
    }
  },
  created () {
    this.getOptions()
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_absence'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_absence'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  mounted () {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },

  methods: {
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    getOptions () {
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_absence.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          /* {"rgpd":"En vertu de la loi","labels":["lname","email*"],"required":["email"]} */
          response.data.DSK_CUSTOM_ABS =
            response.data.DSK_CUSTOM_ABS || '{}'
          this.abs = _.merge(
            { active: response.data.DSK_CUSTOM_ABS_ONOFF === '1' },
            JSON.parse(response.data.DSK_CUSTOM_ABS)
          )
          if (typeof this.abs.required === 'undefined' || !this.abs.required || this.abs.required === null) {
            this.abs.required = []
          }
          try {
            this.DSK_NOBODY_MSG1 = JSON.parse(response.data.DSK_NOBODY_MSG1) || {}
          } catch (error) {}
          try {
            this.DSK_NOBODY_MSG2 = JSON.parse(response.data.DSK_NOBODY_MSG2) || {}
          } catch (error) {}
          this.messagingOnOff = response.data.DSK_MESSAGING_ONOFF === '1'
          this.absOnOff = response.data.DSK_MESSAGING_ONOFF !== '1'
          this.displayDefault = response.data.DSK_OPTIONS.split('|')[0]
        })
        .catch(_ => {
          // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
        })
        .then(_ => {
          this.loadingGet = false
        })
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_HORSLIGNE')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_SETTINGS_HORSLIGNE'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append(
        'LIC_ID',
        this.$store.state._Sites.siteSelected.LIC_ID
      )
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      dataToPost.append('DSK_CUSTOM_ABS_ONOFF', this.abs.active ? '1' : '0')

      let custom2 = _.clone(this.abs)
      let postMessaging = 0
      if (this.messagingOnOff) {
        postMessaging = 1
      }
      delete custom2.active // supprime la clé 'active' de la colonne à mettre à jour
      dataToPost.append('DSK_CUSTOM_ABS', JSON.stringify(custom2))
      dataToPost.append('DSK_NOBODY_MSG1', JSON.stringify(this.DSK_NOBODY_MSG1))
      dataToPost.append('DSK_NOBODY_MSG2', JSON.stringify(this.DSK_NOBODY_MSG2))
      dataToPost.append('DSK_MESSAGING_ONOFF', postMessaging)
      this.loadingPost = true
      this.axios
        .post('post/settings_absence.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          let siteUpdate = _.clone(this.$store.state._Sites.siteSelected)

          this.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate)
          this.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate)
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },

    switchMessaging () {
      if (this.messagingOnOff === true) {
        this.warningMessagingOff = true
        this.absOnOff = false
      } else {
        this.warningMessagingOn = true
        this.absOnOff = true
      }
    },
    switchAbs () {
      if (this.absOnOff === true) {
        this.warningMessagingOn = true
        this.messagingOnOff = false
      } else {
        this.warningMessagingOff = true
        this.messagingOnOff = true
      }
    },

    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Absence.vue